import React from 'react';
import { Container, Nav } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="footer py-4 bg-light">
      <Container className="text-center">
        <p>&copy; 2023 BAKAARO. All rights reserved.</p>
        <Nav className="justify-content-center">
          <Nav.Link href="#">Privacy Policy</Nav.Link>
          <Nav.Link href="#">Terms of Service</Nav.Link>
          <Nav.Link href="#">Contact Us</Nav.Link>
        </Nav>
      </Container>
    </footer>
  );
};

export default Footer;
